class UserPrintableError extends Error {}

export default UserPrintableError;
